var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.188 2.344H2.812c-.776 0-1.406.63-1.406 1.406v8.438c0 .776.63 1.406 1.407 1.406h9.374c.777 0 1.407-.63 1.407-1.406V3.75c0-.777-.63-1.406-1.406-1.406z",
    stroke: "#fff",
    strokeWidth: 0.938,
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M13.594 4.688H1.406M3.75 1.405v.938-.938zm7.5 0v.938-.938z",
    stroke: "#fff",
    strokeWidth: 0.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCalendar;